// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".customLink[data-v-2ecd32f3]{padding:0!important}.customLink[data-v-2ecd32f3],.customLink .customLink_wrapper[data-v-2ecd32f3]{position:relative}.customLink .customLink_wrapper[data-v-2ecd32f3] .wistia_click_to_play{height:100%!important;width:100%!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
